<template>
  <aside
    class="sidebar flex w-[250px] min-w-[250px] flex-col justify-between px-3 py-4 max-md:w-full max-md:min-w-full"
  >
    <div class="flex flex-col gap-5 max-md:gap-3">
      <nav class="flex flex-col gap-1">
        <AppRouterLink
          :to="`/ansokningar`"
          active-class="is-active"
          variant="button"
          class="sidebar-link flex items-center gap-2"
        >
          <SvgIcon :path="mdiMenu" color="white"></SvgIcon>
          <span>Ansökningar</span>
        </AppRouterLink>

        <AppRouterLink
          to="/ny-ansokan"
          active-class="is-active"
          variant="button"
          class="sidebar-link flex items-center gap-2"
        >
          <SvgIcon :path="mdiPlusCircleOutline" color="white"></SvgIcon>
          <span>Ny ansökan</span>
        </AppRouterLink>

        <AppRouterLink
          to="/personal"
          active-class="is-active"
          variant="button"
          class="sidebar-link flex items-center gap-2"
        >
          <SvgIcon :path="mdiAccountGroupOutline" color="white"></SvgIcon>
          <span>Personal</span>
        </AppRouterLink>

        <AppRouterLink
          to="/rantor"
          active-class="is-active"
          variant="button"
          class="sidebar-link flex items-center gap-2"
        >
          <SvgIcon :path="mdiPercent" color="white"></SvgIcon>
          <span>Räntor</span>
        </AppRouterLink>

        <AppRouterLink
          to="/handelser"
          active-class="is-active"
          variant="button"
          class="sidebar-link flex items-center gap-2"
        >
          <SvgIcon :path="mdiHistory" color="white"></SvgIcon>
          <span>Händelser</span>
        </AppRouterLink>
      </nav>
    </div>

    <div class="sidebar-footer">
      <div v-if="userName" class="sidebar-user">
        <span>{{ userName }}</span>
        <span>{{ organisation }}</span>
      </div>
      <AppButton type="button" color="transparent" text-color="white" class="sidebar-logout" @click="$emit('logout')">
        <template #prepend>
          <SvgIcon :path="mdiLogout" color="white"></SvgIcon>
        </template>
        Logga ut
      </AppButton>
    </div>
  </aside>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { AppButton, SvgIcon, useOrganisation } from '@staff/ui'
import AppRouterLink from './AppRouterLink.vue'
import { getStoredToken } from '@/services/auth'
import { usePersonnelDirectory } from '@/composables/usePersonnelDirectory'

import { mdiAccountGroupOutline, mdiHistory, mdiLogout, mdiMenu, mdiPercent, mdiPlusCircleOutline } from '@mdi/js'

defineEmits<{
  logout: []
}>()

const { getPersonnelNameByUserId } = usePersonnelDirectory()
const { getLastOrganisation } = useOrganisation()

const userName = computed(() => getPersonnelNameByUserId(getStoredToken()?.payload?.id))
const organisation = computed(() => getLastOrganisation())
</script>

<style scoped lang="scss">
.sidebar {
  background-color: var(--color-sidebar-bg);
}

.sidebar-link {
  color: var(--color-fg-on-emphasis);

  &:hover {
    background-color: var(--color-sidebar-item-hover-bg);
  }

  &.is-active {
    background-color: var(--color-sidebar-item-active-bg);
  }
}

.sidebar .sidebar-logout:hover {
  background-color: var(--color-sidebar-item-hover-bg);
}

.sidebar-footer {
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
}

.sidebar-user {
  display: flex;
  flex-direction: column;
  // Lines the text up with AppButton's label, which sits behind 12px of padding
  padding-inline: var(--space-12);
  font-size: var(--font-size-xs);
  line-height: var(--font-size-xs-line-height);
  color: var(--color-fg-on-emphasis);
}
</style>
